export enum ModalType {
  UPGRADE = 'UPGRADE',
  CHECKOUT = 'CHECKOUT',
  STORAGE = 'STORAGE',
}
